import { render, staticRenderFns } from "./dashboard-pin.vue?vue&type=template&id=1626d5ba&"
import script from "./dashboard-pin.vue?vue&type=script&lang=js&"
export * from "./dashboard-pin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports